import { render } from "./UiSkeleton.vue?vue&type=template&id=347518c2&ts=true"
import script from "./UiSkeleton.vue?vue&type=script&lang=ts"
export * from "./UiSkeleton.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__